<script setup lang="ts">
import type { CmsElementHeroImageHeadlineTextButton } from "~/composables/useCustom";
import { useWindowSize } from "@vueuse/core";
const props = defineProps<{
  content: CmsElementHeroImageHeadlineTextButton;
}>();

const bannerData = props.content?.data || {};
const {
  heroImageDesktop: { media: desktopImage } = {},
  heroImageMobile: { media: mobileImage } = {},
  button: buttonConfig = {},
} = bannerData;

const { width } = useWindowSize();
const isMobile = computed(() => width.value < 768);
</script>

<template v-if="bannerData">
  <div>
    <div class="herro-banner">
      <div class="mx-auto">
        <div class="wrap px-0 md:px-3.5 lg:px-0">
          <template v-if="mobileImage && desktopImage">
            <NuxtImg
              v-if="isMobile"
              format="webp"
              :src="mobileImage.url"
              class="w-full h-auto"
              :alt="mobileImage.alt"
              loading="eager"
              width="558px"
              height="244px"
            />
            <NuxtImg
              v-else
              format="webp"
              :src="desktopImage.url"
              class="w-full h-auto"
              :alt="desktopImage.alt"
              loading="eager"
              :width="desktopImage.metaData?.width"
              :height="desktopImage.metaData?.height"
            />
          </template>
          <template v-else>
            <NuxtImg
              v-if="desktopImage"
              format="webp"
              :src="desktopImage.url"
              class="w-full h-auto"
              :alt="desktopImage.alt"
              loading="eager"
              :width="desktopImage.metaData?.width"
              :height="desktopImage.metaData?.height"
            />
          </template>
        </div>
      </div>
    </div>

    <div class="upgrade-kitchen mb-0 sm:mb-24 px-4">
      <div class="container mx-auto py-12">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          <div class="text-left">
            <h1 class="h1-sec" v-html="bannerData.headlineText"></h1>
          </div>
          <div class="text-left w-full lg:w-[488px] ml-auto">
            <div
              v-if="bannerData.mainText"
              class="para text-gray-600 mb-6 md:mb-9"
              v-html="bannerData.mainText"
            ></div>
            <SharedButton
              v-if="buttonConfig"
              :button="buttonConfig"
              class="btn-default btn-black-bg"
            >
            </SharedButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
img {
  /* gradient loader background with animation */
  background: linear-gradient(to right, #f4f3f3, #f1f1f1);
  background-size: 200% 100%;
  animation: gradient-animation 3s ease-in-out infinite;
}

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
